import { render, staticRenderFns } from "./ChangedCard.vue?vue&type=template&id=4648922e&scoped=true&"
import script from "./ChangedCard.vue?vue&type=script&lang=js&"
export * from "./ChangedCard.vue?vue&type=script&lang=js&"
import style0 from "./ChangedCard.vue?vue&type=style&index=0&id=4648922e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4648922e",
  null
  
)

export default component.exports